// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"mail"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 4H2V20L22 20V4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M2 4H22V7.44444L12 12.5L2 7.44444V4Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2 4H22M2 4V20L22 20V4M2 4V7.44444L12 12.5L22 7.44444V4","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MailIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mail',
    ref,
    icon: element,
  },
));

MailIcon.displayName = 'MailIcon';

export default MailIcon;
